// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"282fb32f","455":"6ad5a2ce","977":"f9f2e8d3"}[chunkId] + ".chunk.js";
};